const mongoId = (id) => {
  try {
    return id.length === 24 && !id.match(/[^a-z^0-9]/);
  } catch (_e) {
    return false;
  }
};

export default mongoId;
